export default "__VITE_ASSET__DlzKhSsF__"